<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import Vue from "vue";
import themeConfig from "@/../themeConfig.js";
import jwt from "@/http/requests/auth/jwt/index.js";

export default {
  data() {
    return {
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
    notifyServerError() {
      this.$http.interceptors.response.use(
        (response) => {
          return response;
        },
        (error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            Vue.prototype.$Sentry.captureException(
              error.response.data.error.message
            );
            this.$vs.notify({
              time: 3000 + error.response.data.error.message.length * 80,
              color: "danger",
              title: "خطای سروری",
              text: error.response.data.error.message,
            });
          } else if (error == "401") {
            Vue.prototype.$Sentry.captureException(
              "شما مجاز به این درخواست نیستید"
            );
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "خطای دسترسی",
              text: "شما مجاز به این درخواست نیستید",
            });
          } else {
            Vue.prototype.$Sentry.captureException("عدم دسترسی به سرور");
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "عدم دسترسی",
              text: "عدم دسترسی به سرور",
            });
          }
          if (error.response) return Promise.reject(error.response);
          else return Promise.reject(error);
          //
        }
      );
    },
    copy(str,msg) {
      this.$copyText(str).then(
        (e)=> {
          this.$vs.notify({
            time: 4000,
            color: "success",
            title:msg ,
          });
        });
    },
  },
  mounted() {
    this.$helper.copy=this.copy;
    this.notifyServerError();
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  async created() {
    // jwt
    jwt.init();

    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);

    // Auth0
    // try       { await this.$auth.renewTokens() }
    // catch (e) { console.error(e) }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
